import { FileType } from '@office-start/document-types';
var fileTypesWithoutDownloadCapability = new Set([
    FileType.Fluid,
    FileType.FluidActivityBlueprint,
    FileType.Forms,
    FileType.List,
    FileType.MyAnalytics,
    FileType.NewsArticle,
    FileType.None,
    FileType.OneNote,
    FileType.PlayList,
    FileType.PlayLists,
    FileType.Portfolio,
    FileType.PowerBI,
    FileType.Project,
    FileType.ProjectOperations,
    FileType.Sway,
    FileType.UpcomingMeeting,
]);
export function hasDownloadCapability(item) {
    if (!item.fileType || item.isLocalFile || item.isEmailAttachment) {
        return false;
    }
    return !fileTypesWithoutDownloadCapability.has(item.fileType);
}
//# sourceMappingURL=hasDownloadCapability.js.map